﻿// components
import QuestionHeader from './QuestionHeader'

// utils
import * as constants from '../../Utils/constants';


const ManualValidation = () => {

    const onRedirect = () => {
        window.location.href = `${constants.redirects.start}`;
    }

    return (
        <div className="pension-wizard-block__question pension-wizard-block__question__validate">
            <div className="pension-wizard-block__question__card">
                <div className="pension-wizard-block__question__sign__illustration">
                    <img
                        src={`../../../images/info-circle.svg`}
                        alt=''
                    />
                </div>
                <QuestionHeader
                    showCount={false}
                    showApplication={false}
                    headline={constants.manualValidation.headline}
                    text={constants.manualValidation.text}
                />
                <button
                    onClick={onRedirect}
                    type="button"
                    className="button button--green">
                    {constants.manualValidation.buttonText}
                </button>
            </div>
        </div>
    )
}

export default ManualValidation;
